import { PageModel } from "./PageModel";

class TermsConditionsController extends PageModel {

}

export {TermsConditionsController}
